module.exports = __webpack_public_path__ + "card-stack@2x.png?8f9a79c0d441ac93143f061f63f4217c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card-stack@2x.png
// module id = 578
// module chunks = 0